import React, {useEffect, useState} from 'react';
import {useAppDispatch, useAppSelector} from '../../core/hooks';

import Button from '@mui/material/Button'; 
import DeleteIcon from '@mui/icons-material/DeleteForever'

import styles from './usersubscribedbias.module.css';
import {updateSubscribedBiasUsersDBThunk, selectSubscriptionCount, deleteSubscribedBiasThunk, selectMaxSubscriptionCount} from '../../core/reducers/reducer-subscribed-bias';
import { MAX_SUBS } from '../../core/constants';


interface SubscribedBiasUserCheckBoxDropdownProps {
    uidProp: number | null,
    symbolProp: string,
    traderTypeProp: string,
    discordUserNameProp: string
    biasListProp: number[],
}

const biasListMap = [
    {id: 0, label: 'Very Bearish', value: -3},
    {id: 1, label: 'Bearish', value: -2},
    {id: 2, label: 'Slightly Bearish', value: -1},
    {id: 3, label: 'Neutral', value: 0},
    {id: 4, label: 'Slightly Bullish', value: 1},
    {id: 5, label: 'Bullish', value: 2},
    {id: 6, label: 'Very Bullish', value: 3},
];


const SubscribedBiasUserCheckBoxDropdown: React.FC<SubscribedBiasUserCheckBoxDropdownProps> = ({
                                                                                                   uidProp,
                                                                                                   symbolProp,
                                                                                                   traderTypeProp,
                                                                                                   discordUserNameProp,
                                                                                                   biasListProp
                                                                                               }) => {
    const subCount = useAppSelector(selectSubscriptionCount);
    const maxSubs = useAppSelector(selectMaxSubscriptionCount);
    const [isOpen, setIsOpen] = useState(false);
    const [dropDownSelectedBiasList, setDropDownSelectedBiasList] = useState<number[]>(biasListProp);
    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };

    const closeButton = () => {
        setIsOpen(false)
    };

    const dispatch = useAppDispatch();

    const handleOptionChange = (checkedBias: number) => {
        const nextDropdownSelectedBiasList = dropDownSelectedBiasList.includes(checkedBias) ? dropDownSelectedBiasList.filter((item) => item !== checkedBias) : [...dropDownSelectedBiasList, checkedBias];
        setDropDownSelectedBiasList(nextDropdownSelectedBiasList)
        if (uidProp !== null) {
            // updateSubscribedBiasUsersDB(uidProp, symbolProp, traderTypeProp, discordUserNameProp, nextDropdownSelectedBiasList)

            const updateProps = {
                uid: uidProp,
                symbol: symbolProp,
                traderType: traderTypeProp,
                discordUsername: discordUserNameProp,
                dropDownSelectedBiasList: nextDropdownSelectedBiasList
            }
            dispatch(updateSubscribedBiasUsersDBThunk(updateProps));
        }
        setIsOpen(true)
    };

    const handleClearAllClicked = () => {
        if (uidProp !== null) {
            dispatch(deleteSubscribedBiasThunk({uid: uidProp}));
        }
    }

    useEffect(() => {
        //updating dropdown list state when changing Trader Types
        setDropDownSelectedBiasList(biasListProp)
    }, [biasListProp]);


    return (
        <div className={styles.notifyButton} onClick={toggleDropdown}>
            <div>
                Notify {isOpen ? '' : ''}
            </div>
            {isOpen && (
                <ul className={styles.biasListDropDown}>
                    <div className={styles.crossContainer} >
                        <div className={styles.crossButton} onClick={closeButton}>
                            X
                        </div>
                    </div>
                    {biasListMap.map((item) => (
                        <div className={styles.biasListItem} key={item.id}>
                            <input className={styles.biasListCheckBox}
                                   type="checkbox"
                                   value={item.label}
                                   checked={dropDownSelectedBiasList.includes(item.value)}
                                   onChange={() => handleOptionChange(item.value)}
                                   disabled={!(dropDownSelectedBiasList.includes(item.value)) && (subCount >= maxSubs)}
                            />
                            <label className={styles.biasListLabel}>
                                {item.label}
                            </label>

                        </div>
                    ))}
                    <div style={{marginTop: 8, fontStyle: 'italic', fontSize: '10pt'}}>Subscriptions Remaining: {maxSubs - subCount}</div>
                    <div><Button startIcon={<DeleteIcon/>} variant='contained' onClick={()=>handleClearAllClicked()} style={{width: '100%'}} disabled={subCount < 1}>Clear All</Button></div>
                </ul>
            )}
        </div>
    );

};


export default SubscribedBiasUserCheckBoxDropdown;